import { TimeFilterDropdown } from "@/pages/contrato/components/time-filter-dropdown";
import { AppContainer } from "@/components/layout/app-container";
import { TableBuilder } from "@/components/table-builder";
import { ContratoCardSection } from "../components/contrato-list/contrato-card-section";
import { useContratoList } from "../hooks/use-contrato-list";
import { HeaderSlot } from "../components/contrato-list/header-slot";
import { TitleSubtitle } from "@/components/table-builder/types";
import { InlineError } from "../components/inline-error";
import { ContratoRow } from "../contrato.types";

export function ContratoList() {
  const { 
    movieId, 
    columns, 
    filterConfig, 
    tableData, 
    isLoading, 
    error, 
    contractStats, 
    tableActions 
  } = useContratoList();

  const titleSubtitle: TitleSubtitle = {
    title: "Lista de todos contratos",
    subtitle: "Filtre os contratos por categoria ou sessão"
  }

  return (
    <AppContainer
      title="Contratos"
      description="Gestão de contratos do projeto"
      button={<TimeFilterDropdown />}
    >
      <div className="space-y-6">
        <ContratoCardSection
          expiring={contractStats.expiring}
          active={contractStats.active}
          completed={contractStats.completed}
        />

        <div className="bg-darkblue rounded-lg p-6">
          {error && !isLoading && (
            <InlineError 
              error={error} 
              entityName="Projeto" 
              entityId={movieId}
              showTips={true}
            />
          )}

          {!error && (
            <TableBuilder<ContratoRow>
              data={tableData}
              columns={columns}
              rowKey="id"
              isLoading={isLoading}
              actions={tableActions}
              filters={filterConfig}
              itemsPerPage={8}
              showSearch={true}
              searchPlaceholder="Procurar..."
              emptyMessage="Nenhum contrato encontrado"
              headerSlot={<HeaderSlot />}
              titleSubtitle={titleSubtitle}
            />
          )}
        </div>
      </div>
    </AppContainer>
  )
}